var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "clientDetails" }, [
      _c("div", { staticClass: "pos-relative w-100" }, [
        _c("div", { staticClass: "bannerTop w-100 pos-relative zindex-0" }, [
          _c(
            "div",
            {
              staticClass: "w-100 h-100 bg-grey3 pos-relative",
              class: {
                "bg-black": _vm.ShopService.shop && _vm.ShopService.shop.Image,
              },
            },
            [
              _vm.ShopService.shop && _vm.ShopService.shop.Image
                ? _c("img", {
                    staticClass: "img-fit pos-relative w-100 h-100",
                    attrs: {
                      src: _vm.UrlService.imagePath(
                        _vm.ShopService.shop.ShopId,
                        _vm.ShopService.shop.Image
                      ),
                      alt: _vm.ShopService.shop.DefaultName,
                    },
                    on: {
                      error: function ($event) {
                        $event.target.src = "dist/assets/no-img.png"
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "gradient-shadow top-0 pos-absolute w-100 h-100",
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "anchor", attrs: { id: "mon-profil" } }),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.currentTab == "profile",
              expression: "currentTab == 'profile'",
            },
          ],
          staticClass: "container mb-40",
          attrs: { id: "editProfil" },
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "bg-white radius-5 shadow-3 py-20 px-20" }, [
            _c(
              "div",
              { staticClass: "row d-flex align-items-stretch flex-wrap" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-8 px-0 mb-20",
                  },
                  [
                    _c("form", { staticClass: "h-100" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-100 h-100 flex-between-center flex-column py-20",
                        },
                        [
                          _c("div", { staticClass: "w-100" }, [
                            _c("div", { staticClass: "w-100" }, [
                              _vm._m(3),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-xs-12 col-sm-12 col-md-8 col-lg-9 mb-40",
                                },
                                [
                                  _c("div", { staticClass: "col-xs-6 mb-20" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-float-label lineInput",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client.FirstName,
                                              expression: "client.FirstName",
                                            },
                                          ],
                                          staticClass: "form-item",
                                          attrs: {
                                            id: "fn",
                                            type: "text",
                                            placeholder: " ",
                                          },
                                          domProps: {
                                            value: _vm.client.FirstName,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.client,
                                                "FirstName",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", { attrs: { for: "fn" } }, [
                                          _vm._v("Prénom"),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-xs-6 mb-20" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-float-label lineInput",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client.LastName,
                                              expression: "client.LastName",
                                            },
                                          ],
                                          staticClass: "form-item",
                                          attrs: {
                                            id: "ln",
                                            type: "text",
                                            placeholder: " ",
                                          },
                                          domProps: {
                                            value: _vm.client.LastName,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.client,
                                                "LastName",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", { attrs: { for: "ln" } }, [
                                          _vm._v("Nom"),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 mb-20" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "has-float-label lineInput",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.client.Email,
                                                expression: "client.Email",
                                              },
                                            ],
                                            staticClass: "form-item",
                                            attrs: {
                                              id: "email",
                                              type: "text",
                                              placeholder: " ",
                                              disabled: "",
                                            },
                                            domProps: {
                                              value: _vm.client.Email,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.client,
                                                  "Email",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: "email" } },
                                            [_vm._v("Adresse e-mail")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-xs-12 mb-20" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "has-float-label lineInput",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.client.Mobile,
                                                expression: "client.Mobile",
                                              },
                                            ],
                                            staticClass: "form-item",
                                            attrs: {
                                              id: "mob",
                                              type: "text",
                                              placeholder: " ",
                                            },
                                            domProps: {
                                              value: _vm.client.Mobile,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.client,
                                                  "Mobile",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: "mob" } },
                                            [_vm._v("Mobile")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-xs-12" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "has-float-label lineInput",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.client.Birthday,
                                              expression: "client.Birthday",
                                            },
                                          ],
                                          staticClass: "form-item",
                                          attrs: {
                                            id: "bd",
                                            type: "date",
                                            placeholder: " ",
                                          },
                                          domProps: {
                                            value: _vm.client.Birthday,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                _vm.client,
                                                "Birthday",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", { attrs: { for: "bd" } }, [
                                          _vm._v("Date de naissance"),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-xs-12" }, [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btnFlat-color2 fsize-18 shadow-1 w-100",
                                attrs: { type: "submit" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.saveDetails()
                                  },
                                },
                              },
                              [
                                _c("span", [_vm._v("Enregistrer")]),
                                _vm._v(" "),
                                _c("i", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.processing,
                                      expression: "processing",
                                    },
                                  ],
                                  staticClass: "loading ml-10",
                                }),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-4 px-0 mb-20",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 w-100 h-100" },
                      [_c("client-password")],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "mes-adresses" } }),
      _vm._v(" "),
      _c("div", { staticClass: "container mb-40" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "bg-white radius-5 shadow-3 py-20 px-20" }, [
          _c(
            "div",
            { staticClass: "row d-flex flex-wrap align-items-stretch" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0 mb-20",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-100 h-100 flex-between-center flex-column",
                    },
                    [
                      _c("div", { staticClass: "w-100" }, [
                        _c("div", { staticClass: "col-xs-12" }, [
                          _c(
                            "ul",
                            {
                              staticClass: "addresses-list overflow-y",
                              staticStyle: { "max-height": "400px" },
                            },
                            _vm._l(_vm.client.addresses, function (address, i) {
                              return _c(
                                "li",
                                {
                                  key: i,
                                  staticClass:
                                    "address-item color-grey1 p-10 cursor-pointer",
                                  class: {
                                    opened: _vm.current.address === address,
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.current.address = address
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex-between-center" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-start-center address-item--top-details",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "arrow fie-icon_dp-arrow fsize-9 color-grey7 mr-10",
                                          }),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "fsize-16 text-bold",
                                              },
                                              [_vm._v(_vm._s(address.AdrLabel))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "fsize-14" },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(address.Address) +
                                                    ", " +
                                                    _vm._s(address.Zip) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(address.City) +
                                                    ",\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(address.Country) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "address-item--actions flex-between-center fsize-24",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.current.address ===
                                                    address,
                                                  expression:
                                                    "current.address === address",
                                                },
                                              ],
                                              staticClass: "flex-start-center",
                                            },
                                            [
                                              _c(
                                                "confirm-popover",
                                                {
                                                  attrs: {
                                                    "confirm-text":
                                                      "Supprimer l'adresse " +
                                                      address.AdrLabel +
                                                      "' ?",
                                                    placement: "left",
                                                  },
                                                  on: {
                                                    go: function ($event) {
                                                      return _vm.deleteAddress(
                                                        address
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "mx-10",
                                                      attrs: {
                                                        disabled:
                                                          !address.AddressId,
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fie-icon_trash hover-opacity cursor-pointer",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mx-10",
                                                  class: {
                                                    active:
                                                      _vm.editingAddress ===
                                                      address,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.editAddress(
                                                        address
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fie-icon_edit hover-opacity cursor-pointer",
                                                  }),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "address-item--details row mx-0 border-top-grey7",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-4 mb-20" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex-start-start" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-uppercase fsize-10 mr-10",
                                                },
                                                [_vm._v("Bâtiment:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-bold fsize-10",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(address.Batiment)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-4 mb-20" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex-start-start" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-uppercase fsize-10 mr-10",
                                                },
                                                [_vm._v("Étage:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-bold fsize-10",
                                                },
                                                [_vm._v(_vm._s(address.Etage))]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-xs-4 mb-20" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex-start-start" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-uppercase fsize-10 mr-10",
                                                },
                                                [_vm._v("Porte:")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-bold fsize-10",
                                                },
                                                [_vm._v(_vm._s(address.Porte))]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-xs-12" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex-start-start flex-column",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-uppercase fsize-10",
                                              },
                                              [_vm._v("Commentaire:")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-bold fsize-10",
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      address.Commentaire
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12 mt-20" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btnFlat-color1 fsize-18 shadow-1 w-100",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.newAddress()
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v("+ Ajouter une nouvelle adresse"),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container mb-40", attrs: { id: "editCreditCards" } },
        [
          _c("div", { staticClass: "anchor", attrs: { id: "mes-cartes" } }),
          _vm._v(" "),
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "bg-white radius-5 shadow-3 py-20 px-20" }, [
            _c(
              "div",
              {
                staticClass:
                  "row d-flex flex-wrap align-items-stretch justify-content-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-7 px-0 mb-20",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "w-100 h-100 flex-center-center flex-column",
                      },
                      [
                        _c("div", { staticClass: "w-100" }, [
                          _vm.client.cards.length
                            ? _c(
                                "div",
                                { staticClass: "col-xs-12 p-0" },
                                [
                                  _c("card-list", {
                                    attrs: {
                                      cards: _vm.client.cards,
                                      "selected-card": _vm.current.card,
                                    },
                                    on: {
                                      "set-card": _vm.selectCard,
                                      "goto-new-card": function ($event) {
                                        return _vm.toggleNewCard()
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "bg-grey3 flex-1 pb-20 pt-40 px-20 radius-18 radius-top-0",
                            },
                            [
                              _c(
                                "confirm-popover",
                                {
                                  attrs: { placement: "top" },
                                  on: {
                                    go: function ($event) {
                                      return _vm.deleteCard(_vm.current.card)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btnFlat-color2 fsize-18 w-100",
                                      attrs: {
                                        disabled: !_vm.current.card,
                                        type: "submit",
                                        "confirm-popover":
                                          "deleteCard(current.card)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\tSupprimer la carte " +
                                          _vm._s(
                                            _vm.current.card &&
                                              _vm.current.card.pan.substr(-4)
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("i", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.processingCard,
                                            expression: "processingCard",
                                          },
                                        ],
                                        staticClass: "loading",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                false
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-5 px-0 mb-20",
                      },
                      [
                        _c("div", { staticClass: "col-xs-12 w-100 h-100" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "radius-18 bg-white border-grey7 w-100 h-100 flex-between-center flex-column",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fsize-18 text-bold text-uppercase color-1 text-center p-20",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tAjouter une carte bancaire\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "w-100 flex-1 flex-between-center flex-column",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "acceptConditions" },
                                    [
                                      _c("label", { staticClass: "switch" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.acceptCgv,
                                              expression: "acceptCgv",
                                            },
                                          ],
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.acceptCgv
                                            )
                                              ? _vm._i(_vm.acceptCgv, null) > -1
                                              : _vm.acceptCgv,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.acceptCgv,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.acceptCgv = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.acceptCgv = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.acceptCgv = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", {
                                          staticClass: "slider bg-grey3 round",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "labelText pl-10" },
                                          [
                                            _vm._v(
                                              "J'accepte les Conditions Générales de Vente"
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      !_vm.acceptCgv
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "color-bo-danger my-5",
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\tVous devez accepter les CGV pour continuer\n\t\t\t\t\t\t\t\t\t\t"
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(6),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.client.comoMembership
      ? _c(
          "div",
          { staticClass: "container mb-40", attrs: { id: "fidelite" } },
          [
            _vm._m(7),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bg-white radius-5 shadow-3 py-20 px-20" },
              [
                _c(
                  "div",
                  { staticClass: "fidelityCards flex-center-center flex-wrap" },
                  [
                    _c(
                      "div",
                      [
                        _c("profile-fidelite-card", {
                          attrs: {
                            card: {
                              nbPoints: _vm.ClientService.getComoBalance(
                                _vm.client
                              ),
                            },
                            client: _vm.client,
                            shop: _vm.ShopService.shop,
                            como: true,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.getFidCards().length
      ? _c(
          "div",
          { staticClass: "container mb-40", attrs: { id: "fidelite" } },
          [
            _vm._m(8),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bg-white radius-5 shadow-3 py-20 px-20" },
              [
                _c(
                  "div",
                  { staticClass: "fidelityCards flex-center-center flex-wrap" },
                  _vm._l(_vm.getFidCards(), function (card, i) {
                    return _c(
                      "div",
                      { key: i },
                      [
                        _c("profile-fidelite-card", {
                          attrs: {
                            card: card,
                            client: _vm.client,
                            shop: _vm.ShopService.shop,
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "pos-absolute top-0 zindex-1 flex-center-center w-100 h-100",
      },
      [_c("div", { staticClass: "headingLine" }, [_vm._v("Mon compte")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "topMenu container" }, [
      _c(
        "div",
        {
          staticClass:
            "flex-center-center bg-white radius-5 shadow-3 p-20 radius-18 radius-top-0 mb-30",
        },
        [
          _c("ul", { staticClass: "flex-center-center mx-10" }, [
            _c("li", { staticClass: "m-10 color-grey1" }, [
              _c(
                "a",
                {
                  staticClass: "flex-center-center",
                  attrs: { href: "#mon-profil" },
                },
                [
                  _c("i", { staticClass: "fsize-24 fie-icon_fingerprint" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "ml-10 text-bold text-uppercase fsize-12" },
                    [_vm._v("Mon profil")]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "m-10 color-grey1" }, [
              _c(
                "a",
                {
                  staticClass: "flex-center-center",
                  attrs: { href: "#mes-adresses" },
                },
                [
                  _c("i", { staticClass: "fsize-24 fie-icon_pin" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "ml-10 text-bold text-uppercase fsize-12" },
                    [_vm._v("Mes adresses")]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "m-10 color-grey1" }, [
              _c(
                "a",
                {
                  staticClass: "flex-center-center",
                  attrs: { href: "#mes-cartes" },
                },
                [
                  _c("i", { staticClass: "fsize-24 fie-icon_credit-card" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "ml-10 text-bold text-uppercase fsize-12" },
                    [_vm._v("Mes cartes")]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "m-10 color-grey1" }, [
              _c(
                "a",
                {
                  staticClass: "flex-center-center",
                  attrs: { href: "#fidelite" },
                },
                [
                  _c("i", { staticClass: "fsize-24 fie-icon_credit-card" }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "ml-10 text-bold text-uppercase fsize-12" },
                    [_vm._v("Ma Fidélité")]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-start-center m-20" }, [
      _c("i", { staticClass: "fie-icon_fingerprint mr-20 fsize-24" }),
      _c(
        "span",
        { staticClass: "fsize-18 color-grey1 text-uppercase text-bold" },
        [_vm._v("Mon profil")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-3 mb-40" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex-center-center bg-grey7 radius-4 py-10 h-100 w-100",
            attrs: { xstyle: "width:200px ; height: 200px;" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "flex-center-center flex-column bg-grey3 radius-circle p-5",
                staticStyle: { width: "155px", height: "155px" },
              },
              [
                _c("img", { attrs: { src: "dist/assets/upload-icon.svg" } }),
                _vm._v(" "),
                _c("span", { staticClass: "m-10 text-center fsize-12" }, [
                  _vm._v("Ajouter ou déposer votre photo"),
                ]),
                _vm._v(" "),
                _c("i", { staticClass: "fie-icon_plus color-2 fsize-22" }),
              ]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-start-center m-20" }, [
      _c("i", { staticClass: "fie-icon_pin mr-20 fsize-24" }),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "fsize-18 color-grey1 text-uppercase text-bold" },
        [_vm._v("Mes adresses de livraison")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-start-center m-20" }, [
      _c("i", { staticClass: "fie-icon_credit-card mr-20 fsize-24" }),
      _c(
        "span",
        { staticClass: "fsize-18 color-grey1 text-uppercase text-bold" },
        [_vm._v("Mes cartes bancaires")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "w-100 bg-grey3 flex-1 pb-20 pt-40 px-20 radius-18 radius-top-0",
      },
      [
        _c(
          "button",
          {
            staticClass: "btnFlat-color1 fsize-18 w-100",
            attrs: { type: "button" },
          },
          [_vm._v("Ajouter")]
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-start-center m-20" }, [
      _c("i", { staticClass: "fie-icon_offer mr-20 fsize-24" }),
      _c(
        "span",
        { staticClass: "fsize-18 color-grey1 text-uppercase text-bold" },
        [_vm._v("Mon Wallet")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-start-center m-20" }, [
      _c("i", { staticClass: "fie-icon_offer mr-20 fsize-24" }),
      _c(
        "span",
        { staticClass: "fsize-18 color-grey1 text-uppercase text-bold" },
        [_vm._v("Ma fidélité")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }